const BANNER_ELIGIBLE_PREFIX = 'prestador_banner_eligible_';
const BANNER_DISMISSED_PREFIX = 'prestador_banner_dismissed_';

function userKey(userId) {
  return String(userId ?? 'anon');
}

export function markPrestadorBannerEligible(userId) {
  try {
    localStorage.setItem(`${BANNER_ELIGIBLE_PREFIX}${userKey(userId)}`, '1');
  } catch {
    /* ignore */
  }
}

export function isPrestadorBannerEligible(userId) {
  try {
    return localStorage.getItem(`${BANNER_ELIGIBLE_PREFIX}${userKey(userId)}`) === '1';
  } catch {
    return false;
  }
}

export function dismissPrestadorBanner(userId) {
  try {
    localStorage.setItem(`${BANNER_DISMISSED_PREFIX}${userKey(userId)}`, '1');
  } catch {
    /* ignore */
  }
}

export function isPrestadorBannerDismissed(userId) {
  try {
    return localStorage.getItem(`${BANNER_DISMISSED_PREFIX}${userKey(userId)}`) === '1';
  } catch {
    return false;
  }
}
